/**
 * Pobiera element znajdujący się w obiekcie pod daną ścieżką
 *
 * @export
 * @param {*} obj
 * @param {(string | string[])} objectPath
 * @returns {*}
 */
export function getPath(obj: any, objectPath: string | string[]): any {
  if (!Array.isArray(objectPath)) {
    objectPath = objectPath.split('.');
  }
  return objectPath.reduce((current, key) => current?.[key], obj);
}
